export const versionControl = {
  core: {
    version: "v0.0.1e",
  },
};
